export default __webpack_public_path__ + "static/media/Stephanie-Zach-1.9538ed49.webp";